import {
    faRedoAlt,
    faUserCheck,
    faUserEdit,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import classNames from 'classnames';
import { DaylightContext } from '../../../../../DaylightCodeMapper';
import './styles.css';

const ReviewConfirmMapping = ({ code, isUpdating }) => {
    const dispatch = useDispatch();
    let buttonIcon = faRedoAlt;
    if (!isUpdating) buttonIcon = code?.needsReview ? faUserCheck : faUserEdit;
    // TODO: make sure this is working correctly
    const { practiceId, partnerId } = useContext(DaylightContext);
    // TODO: force some breaking behavior so we can ensure our error handling is on point
    const handleMarkingForReview = (code) => {
        if (code?.needsReview) {
            dispatch(
                actions.daylight.unmarkCodeForReview(
                    practiceId,
                    code,
                    partnerId
                )
            );
        } else {
            dispatch(
                actions.daylight.markCodeForReview(practiceId, code, partnerId)
            );
        }
    };

    return (
        <FontAwesomeIcon
            className={classNames('review-mapping pop-hoverable', {
                rotating: isUpdating,
                'fa-disabled': isUpdating,
            })}
            icon={buttonIcon}
            onClick={() => handleMarkingForReview(code)}
            title={code?.needsReview ? 'Confirm mapping' : 'Mark for review'}
            size="lg"
        />
    );
};

export default ReviewConfirmMapping;
